import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from "react";
import { ArrowSmallDownIcon } from "../../../generated";
export const SmallDirectionalTriangleIcon = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    color,
    size,
    rotation,
    style,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(ArrowSmallDownIcon, _extends({
    color: color,
    ref: ref,
    size: size,
    style: {
      transform: `rotate(${rotation + 180}deg)`,
      ...style
    }
  }, rest));
});
SmallDirectionalTriangleIcon.displayName = "SmallDirectionalTriangleIcon";
//# sourceMappingURL=SmallDirectionalTriangleIcon.js.map